/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

import { IAgriculturalIncomes } from "../../../../config/interfaces";
import PriceDisplay from "../../../PriceDisplay";
import { FormField, NumericInputField } from "../../../fields";

const OIAgricultureIncomeDetailsForm = () => {
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<IAgriculturalIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});

  useEffect(() => {
    let _totalInput: { [key: string]: number } = {
      GrossAgricultureReceipt: parseInt(values?.GrossAgricultureReceipt) || 0,
      ExpenditureOnAgriculture: parseInt(values?.ExpenditureOnAgriculture) || 0,
      UnabsorbedAgricultureLoss: parseInt(values?.UnabsorbedAgricultureLoss) || 0
    };

    let _sum = 0;
    if (_totalInput?.GrossAgricultureReceipt) {
      _sum += _totalInput?.GrossAgricultureReceipt;
    }
    if (_totalInput?.ExpenditureOnAgriculture) {
      _sum -= _totalInput?.ExpenditureOnAgriculture;
    }
    if (_totalInput?.UnabsorbedAgricultureLoss) {
      _sum -= _totalInput?.UnabsorbedAgricultureLoss;
    }

    setInputTotal(() => _totalInput);
    setSum(() => _sum);
    setFieldValue("AgrNetIncome", _sum);
  }, []);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);

    let _sum = 0;
    if (inputTotal?.GrossAgricultureReceipt) {
      _sum += inputTotal?.GrossAgricultureReceipt;
    }
    if (inputTotal?.ExpenditureOnAgriculture) {
      _sum -= inputTotal?.ExpenditureOnAgriculture;
    }
    if (inputTotal?.UnabsorbedAgricultureLoss) {
      _sum -= inputTotal?.UnabsorbedAgricultureLoss;
    }
    setSum(() => _sum);
    setFieldValue("AgrNetIncome", _sum);
  };

  return (
    <>
      <div className="section-title-wrap">
        <h5>Income Details</h5>
      </div>
      <Card className="more-info-card shadow-none mb-5">
        <Card.Header>
          <Card.Title>Agricultural Income Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FormField label="Gross Receipt" sm={6} isRequired={true}>
              <NumericInputField
                showLeftIcon={true}
                name="GrossAgricultureReceipt"
                value={values?.GrossAgricultureReceipt || ""}
                onBlur={handleBlur("GrossAgricultureReceipt")}
                onChange={(value) => {
                  setFieldValue("GrossAgricultureReceipt", value);
                  setTimeout(() => {
                    handleAmountInc(parseInt(value), "GrossAgricultureReceipt");
                  }, 100);
                }}
                isInvalid={
                  Boolean(errors.GrossAgricultureReceipt) && touched.GrossAgricultureReceipt
                }
                errorMsg={errors.GrossAgricultureReceipt}
              />
            </FormField>

            <FormField label="Expenditure Incurred" sm={6} isRequired={true}>
              <NumericInputField
                showLeftIcon={true}
                name="ExpenditureOnAgriculture"
                value={values?.ExpenditureOnAgriculture || ""}
                onBlur={handleBlur("ExpenditureOnAgriculture")}
                onChange={(value) => {
                  setFieldValue("ExpenditureOnAgriculture", value);
                  setTimeout(() => {
                    handleAmountInc(parseInt(value), "ExpenditureOnAgriculture");
                  }, 100);
                }}
                isInvalid={
                  Boolean(errors.ExpenditureOnAgriculture) && touched.ExpenditureOnAgriculture
                }
                errorMsg={errors.ExpenditureOnAgriculture}
              />
            </FormField>

            <FormField label="Unabsorbed Agricultural Loss" sm={6} isRequired={true}>
              <NumericInputField
                showLeftIcon={true}
                name="UnabsorbedAgricultureLoss"
                value={values?.UnabsorbedAgricultureLoss || ""}
                onBlur={handleBlur("UnabsorbedAgricultureLoss")}
                onChange={(value) => {
                  setFieldValue("UnabsorbedAgricultureLoss", value);
                  setTimeout(() => {
                    handleAmountInc(parseInt(value) || 0, "UnabsorbedAgricultureLoss");
                  }, 100);
                }}
                isInvalid={
                  Boolean(errors.UnabsorbedAgricultureLoss) && touched.UnabsorbedAgricultureLoss
                }
                errorMsg={errors.UnabsorbedAgricultureLoss}
              />
            </FormField>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Net Agricultural Receipt:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </>
  );
};

export default OIAgricultureIncomeDetailsForm;
